import clsx from "clsx";
import { ChangeEvent, useCallback, useRef } from "react";
import { FormControlChildProps } from "../form-control";

interface InputProps extends FormControlChildProps {
  /**
   * Default: ''
   */
  label?: string;

  /**
   * Default: ''
   */
  labelClassName?: string;

  /**
   * Default: ''
   */
  className?: string;

  errorClassName?: string;

  width?: number | string;

  /**
   * Default: undefined
   */
  defaultStatus?: undefined | "valid" | "inValid" | "warn";

  /**
   * Default: false
   */
  isMultiple?: boolean;

  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}

function FileInput({
  id,
  formik,
  label = undefined,
  className = "",
  labelClassName = "",
  name,
  disabled = false,
  isMultiple = false,
  width,
  status,
  defaultStatus = undefined,
  errorClassName = "",
  onChange = () => {},
  fmOnChange,
}: InputProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      onChange && onChange(e);
      fmOnChange && fmOnChange(e);

      setTimeout(() => {
        if (formik) formik.setFieldTouched(name!, true);
      });
    },
    [fmOnChange, formik, name, onChange]
  );

  const isError =
    status === "inValid" ||
    status === "warn" ||
    defaultStatus === "inValid" ||
    defaultStatus === "warn";

  return (
    <div className={`box-border w-full ${className}`} style={{ width }}>
      <div className={labelClassName}>{label}</div>
      <label className="w-full flex relative">
        <input
          ref={inputRef}
          id={id}
          className={clsx(
            "text-sm text-grey-500 file:mr-5 file:py-2 file:px-6 file:rounded-full file:border-0",
            "file:text-sm file:font-medium file:bg-blue-50 file:text-blue-700",
            "hover:file:cursor-pointer hover:file:bg-amber-50 hover:file:text-amber-700"
          )}
          type="file"
          multiple={isMultiple}
          name={name}
          onChange={handleChange}
          disabled={disabled}
        />
      </label>
      {isError && (
        <div className={`flex error-color text-xs ${errorClassName}`}>
          {formik &&
            formik.getFieldMeta(name!).error &&
            formik.getFieldMeta(name!).error}
        </div>
      )}
    </div>
  );
}

export default FileInput;
